<div class="called-volume ecall-background-color-mill card-block-off row"></div>
<copo-ecalloff-header objectTranslationKey="ecall-off.order-items" [copyTo]="this.stepState?.copyTo ?? ''"
	[customerCalloffReference]="this.stepState?.customerCalloffReference ?? ''"
	[nbOrderItems]="this.stepState?.selectedOrderItems?.length ?? 0" [rddMode]="this.stepState?.rddMode"
	[totalWeight]="getTotalWeight()"></copo-ecalloff-header>
<div class="card-title-block-non-sticky">
	<div class="card-title-label">
		<span [translateParams]="{objects: 'ecall-off.order-items' | translate }"
			translate>ecall-off.ready-to-call</span><span>&#58;</span>
	</div>
</div>
<div class="card-info-block grid-container" *ngFor="let group of groupCalledVolume">
	<div class="grid-column-one-full copo-container card-portal">
		<div class="call-off-infoentry-form-row">
			<div class="card-row">
				<mat-icon class="row-icon certificate-info-label" svgIcon="at_consignment"></mat-icon>
				<ng-container *ngIf="group.millCodeGroup && group.millCodeGroup.length > 0">{{group.millCode
					?
					group.millCodeGroup[0].millDescription: UNDERSCORE}}</ng-container>
			</div>
			<div>
				<div class="card-content-label" translate>eoffer.cart.volume.request</div>
				<div>
					<span class="center-alignment text-display-orange">
						<div class="copo-request-text">{{group.requestedVolume !== undefined ?
							(group.requestedVolume | copoNumber:'weight':'t') : UNDERSCORE}}</div>
						</span>
				</div>
			</div>
		</div>
		<div *ngFor="let volumes of group.millCodeGroup; let i = index;">

			<div class="ecall-background-color by-volume-item grid-column-one-full grid-5">
				<!-- Customer order number / callable weight column -->
				<div class="customer-order-number-wrapper">
					<div class="customer-order-number">
						<div translate class="label">filter.customerOrderNumber</div>
						<div>{{ getCustomerOrderNumber(volumes?.customerOrderItem,volumes?.customerOrderReference) }}</div>
					</div>
					<div class="customer-order-number">
						<div translate class="label" *ngIf="volumes.shipTo && volumes.shipTo.length > 0">
							ecall-off.ship-to</div>
						<div>{{ volumes.originalShipToDescription }}</div>
					</div>
				</div>
				<!-- Supplier order number column -->
				<div class="supplier-order-number">
					<div translate class="label">filter.supplierOrderNumber</div>
					<div>{{ getSupplierOrderNumber(volumes?.supplierOrderItem , volumes?.supplierOrderReference) }}</div>
				</div>
				<!--  Unloading reference / Steelgrade / dimensions column -->
				<div>
					<div translate class="label">ecall-off.unloading-reference</div>
					<span>
						{{ volumes.unloadingReference ? volumes.unloadingReference : UNDERSCORE }}
					</span>
				</div>
				<!--  Ship To Summary -->
				<div>
					<div translate class="label" *ngIf="volumes.shipTo && volumes.shipTo.length > 0">
						ecall-off.requested-ship-to</div>
					<div>{{ volumes.shipToDescription }}</div>
				</div>

				<!-- Dates column -->

				<div *ngIf="(volumes.requestedDeliveryDateFrom || volumes.requestedDeliveryDateTo)"
					class="dates two-fields-wrapper">
					<div *ngIf="volumes.requestedDeliveryDateFrom" class="date-from">
						<div class="label">{{ (volumes.requestedDeliveryDateTo &&
							volumes.requestedDeliveryDateTo !== volumes.requestedDeliveryDateFrom ? 'filter.number.from' :
							'ecall-off.requested-date') | translate }}</div>
						<div>{{ volumes.requestedDeliveryDateFrom | copoDate:'date' }}</div>
					</div>
					<div *ngIf="volumes.requestedDeliveryDateTo && volumes.requestedDeliveryDateTo !== volumes.requestedDeliveryDateFrom"
						class="date-to">
						<div class="label">{{ (volumes.requestedDeliveryDateFrom ? 'filter.date.to' :
							'ecall-off.requested-date') | translate }}</div>
						<div>{{ volumes.requestedDeliveryDateTo | copoDate:'date' }}</div>
					</div>
				</div>
				<!-- Comment column -->
				<div class="card-row comment-gap" *ngIf="canShowComments">
					<mat-icon svgIcon="comment"></mat-icon>
					<span>
						{{volumes.comment && volumes.comment.length > 0 ? volumes.comment : UNDERSCORE}}</span>
				</div>
				<div class="card-row request-volume">
					<div class="text-big">{{ volumes.requestedVolume }}</div>
					<div class="label" translate>
						ecall-off.called-volume
					</div>
				</div>
			</div>
		</div>
	</div>
</div>